import React from "react";
import { Loader2 } from "lucide-react";

const State = ({ analytics, isLoading }) => {
  const cards = [
    {
      name: "Total Registered Users",
      value: analytics?.totalRegisteredUsers,
      icon: "/assets/images/icons/total-user.svg",
    },
    {
      name: "Pending Approvals",
      value: analytics?.pendingApprovals,
      icon: "/assets/images/icons/pending-approvals.svg",
    },
    {
      name: "Active Nonprofits",
      value: analytics?.activeNonprofits,
      icon: "/assets/images/icons/events.svg",
    },
    {
      name: "Total Events",
      value: analytics?.totalEvents,
      icon: "/assets/images/icons/events.svg",
    },
  ];

  return (
    <div className="bg-darkTheme rounded-lg py-6 flex items-center">
      <div className="w-[90%] lg:w-[97%] mx-auto flex flex-col lg:flex-row lg:justify-between gap-y-3 lg:gap-y-0">
        {cards.map((item, i) => (
          <div key={i} className="lg:w-[24%] flex items-center gap-x-2">
            <div className="bg-white rounded-xl size-14 flex justify-center items-center flex-shrink-0">
              <img src={item.icon} alt={item.name} className="size-6" />
            </div>
            <div className="text-white">
              <p className="font-popinsSemiBold text-xs">{item.name}</p>
              {isLoading ? (
                <Loader2 className="animate-spin mt-1" size={20} />
              ) : (
                <p className="font-popinsBold text-3xl">
                  {item.value?.toLocaleString() ?? "—"}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default State;
